<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-alert
              v-show="valid ? false : true"
              show
              dismissible
              variant="danger"
            >
              <i class="mdi mdi-block-helper mr-2"></i
              >{{ $t("advanced.invalid") }}
            </b-alert>
            <!-- <hr> -->
            <form class="needs-validation" @submit.prevent="searchData()">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="validationCustom01">{{
                      $t("advanced.first-name")
                    }}</label>
                    <input
                      id="validationCustom01"
                      v-model="form.f_name"
                      type="text"
                      class="form-control"
                      :placeholder="$t('advanced.first-name')"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="validationCustom02">{{
                      $t("advanced.last-name")
                    }}</label>
                    <input
                      id="validationCustom02"
                      v-model="form.l_name"
                      type="text"
                      class="form-control"
                      :placeholder="$t('advanced.last-name')"
                      :class="{
                        'is-invalid': submitted && $v.form.l_name.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.l_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.l_name.required">{{
                        $t("advanced.invalid")
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="validationCustom02">{{
                      $t("advanced.email")
                    }}</label>
                    <input
                      id="validationCustom02"
                      v-model="form.email"
                      type="text"
                      class="form-control"
                      :placeholder="$t('advanced.email')"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="validationCustom03">{{
                      $t("advanced.phone")
                    }}</label>
                    <input
                      id="validationCustom03"
                      v-model="form.phone"
                      type="text"
                      class="form-control"
                      :placeholder="$t('advanced.phone')"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4"></div>
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label
                      ><b>{{ $t("form.citizen.label.search-range") }}</b></label
                    >
                    <vue-slide-bar
                      v-model="search_value"
                      :min="0"
                      :max="1000"
                    />
                    <b-button-group class="mt-1 btn-group-sm">
                      <b-button variant="secondary" @click="search_value -= 1">
                        <i class="fas fa-minus"></i>
                      </b-button>
                      <b-form-input
                        ref="input-size"
                        size="sm"
                        for="text"
                        :value="search_value"
                        maxlength="4"
                        v-model="search_value"
                        style="width: 50px"
                      ></b-form-input>
                      <b-button variant="secondary" @click="search_value += 1">
                        <i class="fas fa-plus"></i>
                      </b-button>
                    </b-button-group>
                  </div>
                  <button
                    class="btn btn-block btn-primary float-right"
                    type="submit"
                  >
                    <b-spinner
                      small
                      v-if="loading.search"
                      class="mr-2"
                    ></b-spinner>
                    <span v-if="loading.search">{{
                      $t("button.search.loading")
                    }}</span>
                    <i class="fas fa-search mr-2" v-if="!loading.search"></i>
                    <span v-if="!loading.search">{{
                      $t("button.search.label")
                    }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class=""></div>

    <div class="row mt-3 mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">
              Social Media {{ $t("table.header-label") }}
            </h5>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("table.show-label") }}&nbsp;
                    <b-form-select
                      v-model="socmed.perPage"
                      size="sm"
                      :options="socmed.pageOptions"
                    ></b-form-select
                    >&nbsp;{{ $t("table.entri-label") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("button.search.label") }}:
                    <b-form-input
                      v-model="socmed.filter"
                      type="search"
                      :placeholder="$t('navbar.search.text')"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="socmed.tableData"
                :fields="socmed.fields"
                bordered
                responsive="sm"
                :per-page="socmed.perPage"
                :current-page="socmed.currentPage"
                :sort-by.sync="socmed.sortBy"
                :sort-desc.sync="socmed.sortDesc"
                :filter="socmed.filter"
                :filter-included-fields="socmed.filterOn"
                @filtered="onFilteredSocmed"
                show-empty
              >
                <template #empty>
                  <h6 class="text-center">
                    {{
                      loading.socmed ? "Loading ..." : $t("table.empty-text")
                    }}
                  </h6>
                </template>
                <template #cell(actions)="row">
                  <b-button
                    class="mx-1 my-1 btn-sm btn-secondary btn"
                    @click="openAddSocmed(row.item)"
                  >
                    <i class="fas fa-user-plus"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row" v-if="rows_socmed > 10">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="socmed.currentPage"
                      :total-rows="rows_socmed"
                      :per-page="socmed.perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">
              E-Commerce {{ $t("table.header-label") }}
            </h5>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("table.show-label") }}&nbsp;
                    <b-form-select
                      v-model="ecomm.perPage"
                      size="sm"
                      :options="ecomm.pageOptions"
                    ></b-form-select
                    >&nbsp;{{ $t("table.entri-label") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("button.search.label") }}:
                    <b-form-input
                      v-model="ecomm.filter"
                      type="search"
                      :placeholder="$t('navbar.search.text')"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="ecomm.tableData"
                :fields="ecomm.fields"
                bordered
                responsive="sm"
                :per-page="ecomm.perPage"
                :current-page="ecomm.currentPage"
                :sort-by.sync="ecomm.sortBy"
                :sort-desc.sync="ecomm.sortDesc"
                :filter="ecomm.filter"
                :filter-included-fields="ecomm.filterOn"
                @filtered="onFilteredEcomm"
                show-empty
              >
                <template #empty>
                  <h6 class="text-center">
                    {{ loading.ecomm ? "Loading ..." : $t("table.empty-text") }}
                  </h6>
                </template>
                <template #cell(actions)="row">
                  <b-button
                    class="mx-1 my-1 btn-sm btn-secondary btn"
                    @click="openAddEcomm(row.item)"
                  >
                    <i class="fas fa-user-plus"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row" v-if="rows_ecomm > 10">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="ecomm.currentPage"
                      :total-rows="rows_ecomm"
                      :per-page="ecomm.perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">
              Potential Breach {{ $t("table.header-label") }}
            </h5>
            <div class="col-12" style="min-height: 10vh; max-height: 50vh">
              <div>
                <div class="row mt-4">
                  <div
                    class="col-12 mb-4"
                    v-if="exposed.length != 0 && exposed[0].profile"
                  >
                    <span>Related Target</span>
                    <div class="d-flex">
                      <div
                        class="social-source text-center mt-3 mx-2 px-2"
                        v-for="(tr, idx) in exposed[0].profile"
                        :key="idx"
                      >
                        <div class="avatar-sm mx-auto mb-3">
                          <img
                            :src="urlimage + tr.image_project"
                            class="rounded-circle avatar-sm m-1"
                            alt
                          />
                        </div>
                        <p class="text-muted mb-0">
                          {{ tr.title }}
                        </p>
                      </div>
                    </div>
                    <hr />
                  </div>
                  <div class="col-12 mb-2" v-if="exposed != 0">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      {{ $t("advanced.result-found") }}
                      {{ exposed.length }} {{ $t("advanced.from-breach") }}
                      <div>
                        <b-button
                          variant="success"
                          class="btn-sm"
                          @click="openAddExposed"
                        >
                          <!-- <span>
                            <i class="mdi mdi-loading mdi-spin"></i>
                            {{ $t("advanced.saving") }}
                          </span> -->
                          <span> {{ $t("advanced.save-to-target") }}</span>
                        </b-button>
                      </div>
                    </div>
                  </div>

                  <div
                    v-for="(e, index) in exposed"
                    :key="index"
                    class="col-sm-3 py-2"
                  >
                    <div
                      class="d-block border border-primary rounded p-2 h-100"
                    >
                      <div
                        class="
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <h5 class="text-truncate">{{ e.source }}</h5>
                        <i v-if="!e.has_password" class="bx bxs-lock bx-sm"></i>
                        <i
                          v-if="e.has_password"
                          class="text-success bx bxs-lock-open bx-sm"
                        ></i>
                      </div>
                      <hr />
                      <div class="text-xs">
                        <small v-if="e.has_password"
                          >Password : {{ e.password }}</small
                        ><br />
                        <small v-if="e.has_password"
                          >Password Hash : {{ e.hash }}</small
                        >
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-sm-12 text-center"
                    v-if="!loading.exposed && exposed.length < 1"
                  >
                    <p class="text-secondary p-5">
                      {{ $t("overview.table.all.dnf") }}
                    </p>
                  </div>
                  <div class="col-sm-12 text-center" v-if="loading.exposed">
                    <p class="text-secondary p-5">Loading ...</p>
                  </div>

                  <!-- <div
                    v-if="error !== '' && !loading.search"
                    class="row mt-5 mb-5 pb-4 mx-auto"
                  >
                    <div class="text-center">
                      <span class="text-secondary">{{ error }}</span>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div
      class="row mt-3"
      v-if="
        !socmed.tableData[0] && !ecomm.tableData[0] && search && error == ''
      "
    >
      <div class="col-12">
        <div class="card pt-5 pb-5">
          <div class="card-body p-5">
            <h6 class="text-center text-secondary">{{ $t("all.dnf") }}</h6>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row mt-3"
      v-if="
        !socmed.tableData[0] && !ecomm.tableData[0] && search && error !== ''
      "
    >
      <div class="col-12">
        <div class="card pt-5 pb-5">
          <div class="card-body p-5">
            <h6 class="text-center text-secondary">{{ error }}</h6>
          </div>
        </div>
      </div>
    </div> -->

    <!-- modal add socmed to project -->
    <b-modal
      size="lg"
      hide-footer
      :id="'modal-add-fb-to-project'"
      centered
      :title="'Add to project'"
      title-class="font-18"
    >
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mt-1">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      {{ $t("all.show") }}&nbsp;&nbsp;
                      <b-form-select
                        v-model="target.perPage"
                        size="sm"
                        :options="target.pageOptions"
                        class="mx-1"
                      ></b-form-select
                      >&nbsp;&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="target.filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive">
                <b-table
                  :items="target.tableData"
                  :fields="target.fields"
                  bordered
                  responsive="sm"
                  :per-page="target.perPage"
                  :current-page="target.currentPage"
                  :sort-by.sync="target.sortBy"
                  :sort-desc.sync="target.sortDesc"
                  :filter="target.filter"
                  :filter-included-fields="target.filterOn"
                  @filtered="onFilteredTarget"
                  show-empty
                >
                  <template #empty>
                    <h6 class="text-center" v-if="!loading.target">
                      {{ $t("table.empty-text") }}
                    </h6>
                    <h6 class="text-center" v-if="loading.target">
                      <i class="bx bx-loader bx-spin bx-md"></i>
                    </h6>
                  </template>
                  <template #cell(target)="row">
                    <div class="col-sm-12">
                      <div class="media">
                        <img
                          :src="urlimage + row.item.image_project"
                          class="mr-3 rounded-circle avatar-sm"
                          alt="user-pic"
                        />
                        <div class="media-body">
                          <b> {{ row.item.title }}</b> <br />
                          <p class="text-secondary">
                            Updated : {{ formatDate(row.item.updated_at) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <b-button
                      class="mr-2 btn-sm"
                      @click="addSocmedToProject(row.item.id_target)"
                      variant="primary"
                      v-if="!row.item.id_advanced_fb"
                    >
                      <span
                        v-if="
                          (!loading.add.status &&
                            loading.add.id != row.item.id_target) ||
                          loading.add.id != row.item.id_target
                        "
                      >
                        <i class="bx bx-plus"></i> add
                      </span>
                      <span
                        v-if="
                          loading.add.status &&
                          loading.add.id == row.item.id_target
                        "
                      >
                        <i class="bx bx-loader bx-spin"></i> process
                      </span>
                    </b-button>
                    <b-button
                      class="mr-2 btn-sm"
                      @click="
                        updateSocmedToProject(
                          row.item.id_advanced_fb,
                          row.item.id_target
                        )
                      "
                      variant="primary"
                      v-if="row.item.id_advanced_fb"
                    >
                      <span
                        v-if="
                          (!loading.update.status &&
                            loading.update.id != row.item.id_target) ||
                          loading.update.id != row.item.id_target
                        "
                      >
                        <i class="bx bx-edit-alt"></i> update
                      </span>
                      <span
                        v-if="
                          loading.update.status &&
                          loading.update.id == row.item.id_target
                        "
                      >
                        <i class="bx bx-loader bx-spin"></i> process
                      </span>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="target.currentPage"
                        :total-rows="rows_target"
                        :per-page="target.perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- modal add ecoom to project -->
    <b-modal
      size="lg"
      hide-footer
      :id="'modal-add-tp-to-project'"
      centered
      :title="'Add to project'"
      title-class="font-18"
    >
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mt-1">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;&nbsp;
                      <b-form-select
                        v-model="target.perPage"
                        size="sm"
                        :options="target.pageOptions"
                        class="mx-1"
                      ></b-form-select
                      >&nbsp;&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="target.filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  :items="target.tableData"
                  :fields="target.fields"
                  bordered
                  responsive="sm"
                  :per-page="target.perPage"
                  :current-page="target.currentPage"
                  :sort-by.sync="target.sortBy"
                  :sort-desc.sync="target.sortDesc"
                  :filter="target.filter"
                  :filter-included-fields="target.filterOn"
                  @filtered="onFilteredTarget"
                  show-empty
                >
                  <template #empty>
                    <h6 class="text-center" v-if="!loading.target">
                      {{ $t("table.empty-text") }}
                    </h6>
                    <h6 class="text-center" v-if="loading.target">
                      <i class="bx bx-loader bx-spin bx-md"></i>
                    </h6>
                  </template>
                  <template #cell(target)="row">
                    <div class="col-sm-12">
                      <div class="media">
                        <img
                          :src="urlimage + row.item.image_project"
                          class="mr-3 rounded-circle avatar-sm"
                          alt="user-pic"
                        />
                        <div class="media-body">
                          <b> {{ row.item.title }}</b> <br />
                          <p class="text-secondary">
                            Updated : {{ formatDate(row.item.updated_at) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <b-button
                      class="mr-2 btn-sm"
                      @click="addEcommToProject(row.item.id_target)"
                      variant="primary"
                      v-if="!row.item.id_advanced_tokped"
                    >
                      <span
                        v-if="
                          (!loading.add.status &&
                            loading.add.id != row.item.id_target) ||
                          loading.add.id != row.item.id_target
                        "
                      >
                        <i class="bx bx-plus"></i> add
                      </span>
                      <span
                        v-if="
                          loading.add.status &&
                          loading.add.id == row.item.id_target
                        "
                      >
                        <i class="bx bx-loader bx-spin"></i> process
                      </span>
                    </b-button>
                    <b-button
                      class="mr-2 btn-sm"
                      @click="
                        updateEcommToProject(
                          row.item.id_advanced_tokped,
                          row.item.id_target
                        )
                      "
                      variant="primary"
                      v-if="row.item.id_advanced_tokped"
                    >
                      <span
                        v-if="
                          (!loading.update.status &&
                            loading.update.id != row.item.id_target) ||
                          loading.update.id != row.item.id_target
                        "
                      >
                        <i class="bx bx-edit-alt"></i> update
                      </span>
                      <span
                        v-if="
                          loading.update.status &&
                          loading.update.id == row.item.id_target
                        "
                      >
                        <i class="bx bx-loader bx-spin"></i> process
                      </span>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row" v-if="rows_target > 10">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="target.currentPage"
                        :total-rows="rows_target"
                        :per-page="target.perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- modal add exposed to project -->
    <b-modal
      size="lg"
      hide-footer
      :id="'modal-add-ex-to-project'"
      centered
      :title="'Add Potential Breach to Project'"
      title-class="font-18"
    >
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row mt-1">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show&nbsp;&nbsp;
                      <b-form-select
                        v-model="target.perPage"
                        size="sm"
                        :options="target.pageOptions"
                        class="mx-1"
                      ></b-form-select
                      >&nbsp;&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="target.filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control ml-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <!-- Table -->
              <div class="table-responsive mb-0">
                <b-table
                  :items="target.tableData"
                  :fields="target.fields"
                  bordered
                  responsive="sm"
                  :per-page="target.perPage"
                  :current-page="target.currentPage"
                  :sort-by.sync="target.sortBy"
                  :sort-desc.sync="target.sortDesc"
                  :filter="target.filter"
                  :filter-included-fields="target.filterOn"
                  @filtered="onFilteredTarget"
                  show-empty
                >
                  <template #empty>
                    <h6 class="text-center" v-if="!loading.target">
                      {{ $t("table.empty-text") }}
                    </h6>
                    <h6 class="text-center" v-if="loading.target">
                      <i class="bx bx-loader bx-spin bx-md"></i>
                    </h6>
                  </template>
                  <template #cell(target)="row">
                    <div class="col-sm-12">
                      <div class="media">
                        <img
                          :src="urlimage + row.item.image_project"
                          class="mr-3 rounded-circle avatar-sm"
                          alt="user-pic"
                        />
                        <div class="media-body">
                          <b> {{ row.item.title }}</b> <br />
                          <p class="text-secondary">
                            Updated : {{ formatDate(row.item.updated_at) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <b-button
                      class="mr-2 btn-sm"
                      @click="addExposedToProject(row.item.id_target)"
                      variant="primary"
                    >
                      <span
                        v-if="
                          (!loading.add.status &&
                            loading.add.id != row.item.id_target) ||
                          loading.add.id != row.item.id_target
                        "
                      >
                        <i class="bx bx-plus"></i> add
                      </span>
                      <span
                        v-if="
                          loading.add.status &&
                          loading.add.id == row.item.id_target
                        "
                      >
                        <i class="bx bx-loader bx-spin"></i> process
                      </span>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <div class="row" v-if="rows_target > 10">
                <div class="col">
                  <div
                    class="
                      dataTables_paginate
                      paging_simple_numbers
                      float-right
                    "
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="target.currentPage"
                        :total-rows="rows_target"
                        :per-page="target.perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import AdvancedService from "@/helpers/advanced.service";
import PreferenceService from "@/helpers/preference.service.js";
import TargetService from "@/helpers/target-profile.service";
import BreachService from "@/helpers/breach.service";
import VueSlideBar from "vue-slide-bar";

import { required } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import moment from "moment";
import axios from "axios";

export default {
  page: {
    title: "Advanced Search",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { VueSlideBar, Layout, PageHeader },
  data() {
    return {
      backUrl: "",
      urlimage: process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      search_value: 0,
      search: "",
      error: "",
      elastic: "",
      title: "Advanced Search",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Advanced Search",
          active: true,
        },
      ],
      form: {
        f_name: "",
        l_name: "",
        email: "",
        phone: "",
      },
      valid: true,
      submitted: false,
      submitform: false,
      submit: false,
      typesubmit: false,
      socmed: {
        tableData: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "firstName",
        sortDesc: false,
        fields: [
          {
            key: "first_name",
            label: this.$t("advanced.first-name"),
            sortable: true,
          },
          {
            key: "last_name",
            label: this.$t("advanced.last-name"),
            sortable: true,
          },
          { key: "gender", label: this.$t("advanced.gender"), sortable: true },
          { key: "phone", label: this.$t("advanced.phone"), sortable: true },
          {
            key: "actions",
            label: this.$t("table.action"),
            thStyle: "width:10%;",
          },
        ],
      },
      ecomm: {
        tableData: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "name",
        sortDesc: false,
        fields: [
          { key: "full_name", label: this.$t("advanced.name"), sortable: true },
          {
            key: "user_email",
            label: this.$t("advanced.email"),
            sortable: true,
          },
          { key: "sex", label: this.$t("advanced.gender"), sortable: true },
          { key: "phone", label: this.$t("advanced.phone"), sortable: true },
          {
            key: "actions",
            label: this.$t("table.action"),
            thStyle: "width:10%;",
          },
        ],
      },
      target: {
        tableData: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "name",
        sortDesc: false,
        fields: [
          { key: "target", label: "Target", sortable: true },
          { key: "description", label: "Description", sortable: true },
          { key: "category", label: "Category", sortable: true },
          {
            key: "actions",
            label: this.$t("table.citizen.th.action"),
            class: "text-center",
          },
        ],
      },
      loading: {
        socmed: false,
        ecomm: false,
        exposed: false,
        target: false,
        search: false,
        add: {
          id: "",
          status: false,
        },
        update: {
          id: "",
          status: false,
        },
      },
      temp_data: "",
      pref: "",
      api_host: "",
      x_rapidapi_host: "",
      x_rapidapi_key: "",
      exposed: [],
      exposedSource: "",
    };
  },

  validations: {
    form: {
      f_name: {},
      l_name: {},
      email: {},
      phone: {},
    },
  },

  computed: {
    rows_socmed() {
      return this.socmed.tableData.length;
    },
    rows_ecomm() {
      return this.ecomm.tableData.length;
    },
    rows_target() {
      return this.target.tableData.length;
    },
  },

  methods: {
    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPreferences2() {
      let id = 3;
      PreferenceService.getRapidApiByID(id)
        .then((response) => {
          // console.log('pref api =>', response);
          this.pref = response.data.data;
          this.api_host = response.data.data.api_host;
          this.x_rapidapi_host = response.data.data.api_header_host;
          this.x_rapidapi_key = response.data.data.api_header_key;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    openAddExposed() {
      this.loadTarget();
      this.$bvModal.show("modal-add-ex-to-project");
    },
    openAddSocmed(data) {
      this.loadTarget();
      this.$bvModal.show("modal-add-fb-to-project");
      this.temp_data = data;
    },
    openAddEcomm(data) {
      this.loadTarget();
      this.$bvModal.show("modal-add-tp-to-project");
      this.temp_data = data;
    },
    onFilteredSocmed(filteredItems) {
      this.socmed.totalRows = filteredItems.length;
      this.socmed.currentPage = 1;
    },
    onFilteredEcomm(filteredItems) {
      this.ecomm.totalRows = filteredItems.length;
      this.ecomm.currentPage = 1;
    },
    onFilteredTarget(filteredItems) {
      this.target.totalRows = filteredItems.length;
      this.target.currentPage = 1;
    },
    updateEcommToProject(id_advanced_tokped, id_target) {
      this.loading.update.id = id_target;
      this.loading.update.status = true;
      AdvancedService.updateEcomm(id_advanced_tokped, this.temp_data)
        .then(() => {
          this.loading.update.id = "";
          this.loading.update.status = false;
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: "Successfully update project",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$bvModal.hide("modal-add-tp-to-project");
        })
        .catch(() => {
          this.loading.update.id = "";
          this.loading.update.status = false;
          Vue.swal({
            position: "top-end",
            icon: "error",
            title: "Failed update project",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$bvModal.hide("modal-add-tp-to-project");
        });
    },
    updateSocmedToProject(id_advanced_fb, id_target) {
      this.loading.update.id = id_target;
      this.loading.update.status = true;
      AdvancedService.updateSocmed(id_advanced_fb, this.temp_data)
        .then(() => {
          this.loading.update.id = "";
          this.loading.update.status = false;
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: "Successfully update project",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$bvModal.hide("modal-add-fb-to-project");
        })
        .catch(() => {
          this.loading.update.id = "";
          this.loading.update.status = false;
          Vue.swal({
            position: "top-end",
            icon: "error",
            title: "Failed update project",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$bvModal.hide("modal-add-fb-to-project");
        });
    },
    addEcommToProject(id) {
      this.loading.add.id = id;
      this.loading.add.status = true;
      AdvancedService.saveEcomm(this.temp_data)
        .then((response) => {
          this.temp_data = response.data.data;
        })
        .catch(() => {
          Vue.swal({
            position: "top-end",
            icon: "error",
            title: "Failed to save searching data",
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => {
          let data = {
            id_advanced_tokped: this.temp_data.id_advanced_tokped,
          };
          this.updateProject(id, data);
        });
    },
    addSocmedToProject(id) {
      this.loading.add.id = id;
      this.loading.add.status = true;
      AdvancedService.saveSocmed(this.temp_data)
        .then((response) => {
          this.temp_data = response.data.data;
        })
        .catch(() => {
          Vue.swal({
            position: "top-end",
            icon: "error",
            title: "Failed to save searching data",
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => {
          let data = {
            id_advanced_fb: this.temp_data.id_advanced_fb,
          };
          this.updateProject(id, data);
        });
    },
    addExposedToProject(id) {
      this.loading.add.id = id;
      this.loading.add.status = true;
      let data = {
        id_target: id,
        data: this.exposed,
      };
      console.log("Log gpo ");
      BreachService.saveBreach(data)
        .then((response) => {
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.$bvModal.hide("modal-add-ex-to-project");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateProject(id, data) {
      TargetService.updateTargetProfile(id, data)
        .then(() => {
          this.loading.add.id = "";
          this.loading.add.status = false;
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: "Successfully add to project",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$bvModal.hide("modal-add-fb-to-project");
          this.$bvModal.hide("modal-add-tp-to-project");
        })
        .catch((err) => {
          this.loading.add.id = "";
          this.loading.add.status = false;
          Vue.swal({
            position: "top-end",
            icon: "error",
            title: "Failed add to project",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$bvModal.hide("modal-add-fb-to-project");
          this.$bvModal.hide("modal-add-tp-to-project");
        });
    },
    loadTarget() {
      this.loading.target = true;
      this.target.tableData = [];
      TargetService.getTargetBy()
        .then((response) => {
          response.data.data.forEach((element) => {
            const data = {
              id_target: element.id_target,
              title: element.title,
              image_project: element.image_project,
              description: element.description,
              category: element.category.category_name,
              id_advanced_fb: element.id_advanced_fb,
              id_advanced_tokped: element.id_advanced_tokped,
              updated_at: element.updated_at,
            };
            this.target.tableData.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading.target = false;
        });
    },
    async checkInput() {
      this.submitted = true;
      this.$v.$touch();
      if (
        (this.form.f_name == "" &&
          this.form.l_name == "" &&
          this.form.email == "" &&
          this.form.phone == "") ||
        this.$v.$invalid
      ) {
        this.valid = false;
      } else {
        this.valid = true;
      }
      console.log("input chek");
    },
    searchData() {
      this.search = true;
      this.checkInput()
        .then(() => {
          this.loading.search = true;
          this.resetTable();
        })
        .then(() => {
          if (this.valid == true) {
            this.searchSocmed();
            console.log("getSocmed");
          }
        })
        .then(() => {
          if (this.valid == true) {
            this.searchEcomm();
            console.log("getEcomm");
          }
        })
        .then(() => {
          if (this.valid == true) {
            this.getLocalData();
            console.log("getRapid");
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading.search = false;
          }, 1000);
        });
    },
    searchSocmed() {
      let query;
      this.loading.socmed = true;
      this.error = "";
      let data = {
        size: this.search_value,
        query: {
          bool: {
            filter: [
              {
                bool: {
                  filter: [],
                },
              },
            ],
          },
        },
      };
      if (data.query.bool.filter[0].bool.filter.length != 0) {
        data.query.bool.filter[0].bool.filter.push([]);
      }
      if (this.form.f_name != "") {
        query = {
          bool: {
            should: [{ match_phrase: { firstName: this.form.f_name } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.l_name != "") {
        query = {
          bool: {
            should: [{ match_phrase: { lastName: this.form.l_name } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.phone != "") {
        query = {
          bool: {
            should: [{ match_phrase: { phone: this.form.phone } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      AdvancedService.searchSocmed(this.elastic, data)
        .then((response) => {
          response.data.hits.hits.forEach((val) => {
            let gender = "Tidak Diketahui";
            switch (val._source.gender) {
              case "male":
                gender = "Laki-laki";
                break;
              case "female":
                gender = "Perempuan";
                break;
              case "":
                gender = "Tidak Diketahui";
                break;
              default:
                break;
            }
            const data = {
              id_user: val._source.id,
              first_name: val._source.firstName ?? null,
              last_name: val._source.lastName ?? null,
              gender: gender,
              phone: val._source.phone ?? null,
              hometown: val._source.hometown ?? null,
              current_city: val._source.current_city ?? null,
              work: val._source.work ?? null,
              status: val._source.status ?? null,
            };
            this.socmed.tableData.push(data);
          });
          setTimeout(() => {
            this.loading.socmed = false;
          }, 1000);
        })
        .catch((err) => {
          setTimeout(() => {
            this.loading.socmed = false;
          }, 1000);
          console.log("error->", err);
          if (err.response.status == 500) {
            this.error = "Internal server Error";
          } else if (err.response.status == 404) {
            this.error = "Server Not Found";
          } else if (err.response.status == 403) {
            this.error = "Forbidden";
          }
        });
    },
    searchEcomm() {
      this.error = "";
      this.loading.ecomm = true;
      let query;
      let data = {
        size: this.search_value,
        query: {
          bool: {
            filter: [
              {
                bool: {
                  filter: [],
                },
              },
            ],
          },
        },
      };
      if (data.query.bool.filter[0].bool.filter.length != 0) {
        data.query.bool.filter[0].bool.filter.push([]);
      }
      if (this.form.f_name != "") {
        query = {
          bool: {
            should: [
              {
                match_phrase: {
                  full_name: this.form.f_name + " " + this.form.l_name,
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.email != "") {
        query = {
          bool: {
            should: [{ match_phrase: { user_email: this.form.email } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.phone != "") {
        query = {
          bool: {
            should: [{ match_phrase: { phone: this.form.phone } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      AdvancedService.searchEcomm(this.elastic, data)
        .then((response) => {
          response.data.hits.hits.forEach((val) => {
            let regex = /['"]/g;
            let sex = "";
            switch (val._source.sex.replace(regex, "")) {
              case "1":
                sex = "Laki-laki";
                break;
              case "2":
                sex = "Perempuan";
                break;
              case "0":
                sex = "Tidak Diketahui";
                break;
              default:
                break;
            }
            const data = {
              full_name: val._source.full_name.replace(regex, "") ?? null,
              phone: val._source.phone
                ? val._source.phone.replace(regex, "")
                : "-",
              user_email: val._source.user_email.replace(regex, "") ?? null,
              sex: sex,
              hobbies: val._source.hobbies
                ? val._source.hobbies.replace(regex, "")
                : "-",
              pwd: val._source.user_pwd_1
                ? val._source.user_pwd_1.replace(regex, "")
                : "-",
              birth_date: val._source.birth_date
                ? val._source.birth_date.replace(regex, "")
                : "-",
              status: val._source.status.replace(regex, "") ?? null,
            };
            this.ecomm.tableData.push(data);
          });
          setTimeout(() => {
            this.loading.ecomm = false;
          }, 1000);
        })
        .catch((err) => {
          setTimeout(() => {
            this.loading.ecomm = false;
          }, 1000);
          console.log("error->", err);
          if (err.response.status == 500) {
            this.error = "Internal server Error";
          } else if (err.response.status == 404) {
            this.error = "Server Not Found";
          } else if (err.response.status == 403) {
            this.error = "Forbidden";
          }
        });
    },
    getLocalData() {
      this.loading.exposed = true;
      BreachService.getBreach(this.form.email)
        .then((response) => {
          if (response.data.data == 0) {
            this.exposedSource = "rapid";
            this.getRapid();
          } else {
            this.searchSource = "local";
            response.data.data.forEach((element) => {
              const mergeData = {
                ...element.breach,
                ...{ profile: element.profile },
              };

              this.exposed.push(mergeData);
            });
            // this.exposed = response.data.data;
            setTimeout(() => {
              this.loading.exposed = false;
            }, 1000);
          }
        })
        .catch((err) => {
          setTimeout(() => {
            this.loading.exposed = false;
          }, 1000);
          console.log(err);
        });
    },
    getRapid() {
      this.loading.exposed = true;
      this.error = "";
      const options = {
        method: "GET",
        url: this.api_host,
        params: { func: "auto", term: this.form.email },
        headers: {
          "content-type": "application/json",
          "x-rapidapi-host": this.x_rapidapi_host,
          "x-rapidapi-key": this.x_rapidapi_key,
        },
      };
      axios
        .request(options)
        .then((response) => {
          if (response.data.success) {
            response.data.result.forEach((el) => {
              this.exposed.push({
                email: this.form.email,
                has_password: el.has_password,
                password: el.password ?? "",
                hash: el.hash ?? "",
                source: el.sources[0].length > 1 ? el.sources[0] : el.sources,
              });
            });
          } else {
            console.log("rapid not found");
          }
          setTimeout(() => {
            this.loading.exposed = false;
          }, 1000);
        })
        .catch((err) => {
          console.log("rapid error", err.response.status);
          setTimeout(() => {
            this.loading.exposed = false;
          }, 1000);
          if (err.response.status == 500) {
            this.error = "Internal server Error";
          } else if (err.response.status == 404) {
            this.error = "Server Not Found";
          } else if (err.response.status == 403) {
            this.error = "Forbidden";
          }
        });
    },
    resetTable() {
      this.socmed.tableData = [];
      this.ecomm.tableData = [];
    },
    typeForm(e) {
      this.typesubmit = true;
      this.$v.$touch();
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.backUrl = from.path;
    });
  },
  mounted() {
    this.getPreferences();
    this.getPreferences2();
    this.loadTarget();
    this.search_value = 100;
  },
};
</script>